export default [
  {
    header: 'Implementos',
    resource: 'entregallaves',
    action: 'menu',
  },
  {
    title: 'Llaves',
    route: 'entregallaves',
    icon: 'KeyIcon',
    action: 'menu',
    resource: 'entregallaves'
  },
  {
    title: 'Indumentaria',
    route: 'entregaindumentaria',
    icon: 'ShieldIcon',
    action: 'menu',
    resource: 'entregaindumentaria'
  },
  {
    title: 'Busq. Control Ind.',
    route: 'busq_control_ind',
    icon: 'fa-solid fa-shirt',
    action: 'menu',
    resource: 'busq_control_ind'
  },
  {
    title: 'Descuentos',
    route: 'descuentos',
    icon: 'DollarSignIcon',
    action: 'menu',
    resource: 'descuentos'
  },
  {
    title: 'Deserciones',
    route: 'deserciones',
    icon: 'AlertTriangleIcon',
    action: 'menu',
    resource: 'entregallaves'
  },
]
